import React from 'react';
import Grid from './form/Grid';
import withStyles from '@mui/styles/withStyles';
import cx from 'classnames';
import { alpha } from '@mui/material/styles';
const styles = ({ spacing, palette, breakpoints }) => ({
    root: {
        flexGrow: 1,
        margin: spacing(-1.5),
        // v5 Grid spacing uses full values (v4 used half). Override items to match v4.
        '& > .MuiGrid2-root': {
            padding: spacing(1.5)
        },
        [breakpoints.up('lg')]: {
            '& > .MuiGrid2-root': {
                paddingLeft: spacing(4),
                paddingRight: spacing(4)
            },
            '& > .MuiGrid2-root:first-child': {
                // paddingLeft: 0
                //paddingTop: 0
            },
            '& > .MuiGrid2-root:last-child:not(:first-child)': {
                // paddingRight: 0
            },
            '& > .MuiGrid2-root:nth-child(n + 2)': {
                borderLeft: `1px solid ${alpha(palette.divider, 0.05)}`,
                paddingLeft: `calc(${spacing(4)} + 1px)`
            }
        }
    },

    snappableLayout: {
        flexGrow: 1,
        // margin: spacing(-1.5),
        '& > .MuiGrid2-root': {
            // padding: spacing(1.5)
        },
        position: 'relative',
        [breakpoints.up('lg')]: {
            '& > :not(:first-child)': {
                // borderLeft: `1px solid ${palette.divider}`
                outline: '1px solid ' + palette.action.active
            }
        }
    },

    snappableComponent: {
        padding: '0px !important',
        margin: `${spacing(1.5)} 0 0 ${spacing(-1.5)}`,
        [breakpoints.down('lg')]: {
            position: 'absolute',
            zIndex: 1,
            outline: '1px solid ' + palette.action.active,
            right: 12,
            width: 'min(400px, 95%)'
        }
    }
});

const ColumnLayout = withStyles(styles)(({ classes, className, children }) => {
    //for single children, just return the object
    if (!children.length || children.length <= 0) {
        return (
            <Grid container spacing={3} className={cx(classes.root, className)}>
                <Grid item xs={12} lg={12}>
                    {children}
                </Grid>
            </Grid>
        );
    }

    //multi children
    const factor = 12 / children.length;
    return (
        <Grid container spacing={3} className={cx(classes.root, className)}>
            {children.map((child, i) => (
                <Grid key={i} item xs={12} lg={factor}>
                    {child}
                </Grid>
            ))}
        </Grid>
    );
});

const SnappableLayout = withStyles(styles)(({ classes, className, snappableComponent, children }) => {
    const maxWidth = 12;
    const centerWidth = snappableComponent ? 8 : maxWidth;
    const snapWidth = maxWidth - centerWidth;

    return (
        <Grid container spacing={3} className={cx(classes.snappableLayout, className)}>
            <Grid item xs={12} lg={centerWidth}>
                <ColumnLayout children={children} />
            </Grid>
            {snapWidth > 0 && (
                <Grid item xs={12} lg={snapWidth} className={classes.snappableComponent}>
                    {snappableComponent}
                </Grid>
            )}
        </Grid>
    );
});

export default ColumnLayout;
export { SnappableLayout };
